import axios from 'axios'
import _ from 'lodash'
import { push } from 'react-router-redux'

import { logout } from '../actions/auth'
import { setIsLoading } from '../actions/loading'

import { getStore } from '../store/configureStore'

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_URL
})

api.interceptors.request.use((config) => {
  const store = getStore()
  store.dispatch(setIsLoading(true))
  return config
}, (error) => {
  const store = getStore()
  store.dispatch(setIsLoading(false))
  return Promise.reject(error)
})

api.interceptors.response.use((response) => {
  const store = getStore()
  store.dispatch(setIsLoading(false))
  return response
}, async (err) => {
  const store = getStore()
  store.dispatch(setIsLoading(false))
  err.msg = err.message
  if (err.response && err.response.data) {
    err.msg = err.response.data.error || err.response.data.message || err.msg
  }
  if (err.response && err.response.status === 401) {
    await store.dispatch(logout())
    store.dispatch(push('/login'))
    return Promise.reject(err)
  }
  return Promise.reject(err)
})

export const setAuthorizationHeader = (token) => {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

const item = JSON.parse(localStorage.getItem('sansiri-defect-report-admin'))
const token = _.get(item, 'auth.token')

async function init (token) {
  setAuthorizationHeader(token)
  const { data } = await api.get('/api/auth/renew')
  setAuthorizationHeader(data.token)
  localStorage.setItem('sansiri-defect-report-admin', JSON.stringify(_.merge(item, { auth: { token: data.token } })))
}

if (token) {
  init(token)
}

export default api


// WEBPACK FOOTER //
// ./src/lib/api.js